import React from "react";
import { Box, Grid, Slide, Typography, CardMedia } from "@mui/material";
import SwipeableTextMobileStepper from "./MobileStepper";
import { SecondaryStyle } from "../fonts";

import Carousel1Image1 from "../assets/Page2LA1.webp";
import Carousel1Image2 from "../assets/Page2LA2.webp";
import Carousel1Image3 from "../assets/Page2LA3.webp";
import Carousel1Image4 from "../assets/Page2LA4.webp";
import Carousel1Image5 from "../assets/Page2LA5.webp";
import Carousel2Image1 from "../assets/Page2RB1.webp";
import Carousel2Image2 from "../assets/Page2RB2.webp";
import Carousel3Image1 from "../assets/Page2RAB1.webp";
import Carousel3Image2 from "../assets/Page2RAB2.webp";
import RD from "../assets/Page2RD.webp";

//@ts-ignore
import RAT from "../assets/Page2RAT.mp4";

const carousel1Images = [
  Carousel1Image1,
  Carousel1Image2,
  Carousel1Image3,
  Carousel1Image4,
  Carousel1Image5,
];
const carousel2Images = [Carousel2Image1, Carousel2Image2];
const carousel3Images = [Carousel3Image1, Carousel3Image2];

const Page2 = (props) => {
  const { checked, isReverse } = props;

  return (
    <Slide
      direction={isReverse ? "right" : "left"}
      in={checked}
      timeout={{
        enter: 1750,
        exit: 1750,
      }}
    >
      <Box
        sx={{
          width: "100vw",
          height: { xs: "100%", sm: "100vh" },
          overflow: { xs: "auto", sm: "hidden" },
        }}
      >
        <Grid container sx={{ height: "100%" }} id="scrollTarget">
          {/* First Half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12} sm={9.1}>
                <Grid
                  container
                  direction={"row"}
                  sx={{ height: { xs: "35.5vh", sm: "100%" } }}
                >
                  {/* LD/LA/*/}
                  <Grid
                    item
                    xs={12}
                    sx={{
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: ".1vh solid #fff",
                      },
                      borderTop: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                    }}
                  >
                    <SwipeableTextMobileStepper
                      images={carousel1Images}
                      showArrows={true}
                      showDots={true}
                      autoplay={true}
                    />
                  </Grid>
                </Grid>

                {/* LB */}
                <Grid
                  item
                  xs={12}
                  sx={{
                    borderTop: {
                      xs: ".5vh solid #fff",
                      sm: "none",
                    },
                    borderRight: {
                      xs: "none",
                      sm: ".5vh solid #fff",
                    },
                    display: "flex",
                    pb: { xs: 1.5 },
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      ...SecondaryStyle,
                      textAlign: "justify",
                      "@media (orientation: landscape)": {
                        fontSize: { xs: "1vw", md: "1vw", lg: "1vw" },
                        lineHeight: { xs: "1.1vw", md: "1.1vw", lg: "1.1vw" },
                        paddingTop: "2vw",
                        paddingRight: "2vw",
                        paddingLeft: { xs: "2vh", sm: "2vw" },
                      },
                      "@media (orientation: portrait)": {
                        fontSize: {
                          xs: "1.7vh",
                          sm: "1vh",
                        },
                        lineHeight: {
                          xs: "2vh",
                          sm: "1.65vh",
                          md: "1.5vh",
                          lg: "1.8vh",
                        },
                        paddingTop: {
                          xs: "1vh",
                          sm: "2.2vh",
                          md: "1.2vh",
                          lg: "0vh",
                        },
                        px: { xs: "1.5vh", sm: "5vh" },
                      },
                    }}
                  >
                    Bathed in natural light, this living and dining space offers
                    a perfect blend of warmth, style, and functionality. The
                    living room, centered around a charming wood-burning
                    fireplace, invites cozy family evenings or casual gatherings
                    with friends. The seamless flow into the dining area, with
                    its elegant lighting and contemporary touches, makes hosting
                    dinners effortless. Whether you're enjoying quiet nights in
                    or entertaining loved ones, these rooms offer flexibility
                    and comfort for every occasion—designed for both everyday
                    living and special moments.
                  </Typography>
                </Grid>
              </Grid>
              {/* LC/LB */}
            </Grid>
          </Grid>

          {/* 2nd half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    borderBottom: ".5vh solid #fff",
                    height: {
                      sm: "100%",
                    },
                  }}
                >
                  {/* RD */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderRadius: { xs: "16px", sm: "0vh" },
                      height: { xs: "45vh", sm: "50vh" },
                      backgroundImage: `url('${RD}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                    }}
                  />

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderBottom: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderTop: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },

                      height: {
                        xs: "83vh",
                        sm: "100%",
                      },
                      maxHeight: { xs: "100%", sm: "50vh" },
                    }}
                  >
                    <Box
                      sx={{
                        height: { xs: "45vh", sm: "25vh" },
                        borderRadius: { xs: "16px", sm: "0vh" },
                        borderBottom: {
                          xs: ".5vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                      }}
                    >
                      <CardMedia
                        component={"video"}
                        sx={{
                          borderRadius: { xs: "16px", sm: "0vh" },
                          height: "100%",
                          objectFit: "cover",
                          objectPosition: "50% 90%",
                        }}
                        src={RAT}
                        autoPlay
                        muted
                        loop
                        playsInline
                      />
                    </Box>

                    <Box
                      sx={{
                        height: { xs: "36vh", sm: "24vh" },

                        borderRadius: { xs: "16px", sm: "0vh" },
                        borderTop: ".5vh solid #fff",
                      }}
                    >
                      <SwipeableTextMobileStepper
                        images={carousel3Images}
                        autoplay={false}
                      />
                    </Box>
                  </Grid>
                  <Grid
                    container
                    direction={"row"}
                    sx={{
                      height: { xs: "36vh", sm: "50vh" },
                    }}
                  >
                    {/**RC */}
                    <Grid
                      item
                      xs={12}
                      sx={{
                        borderTop: {
                          xs: ".5vh solid #fff",
                          sm: "1vh solid #fff",
                        },
                        borderBottom: {
                          xs: ".5vh solid #fff",
                          sm: "none",
                        },
                        borderLeft: {
                          xs: "1vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                        borderRadius: { xs: "16px", sm: "0vh" },
                        borderRight: {
                          xs: "1vh solid #fff",
                          sm: "none",
                        },
                      }}
                    >
                      <SwipeableTextMobileStepper images={carousel2Images} />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

export default Page2;
